export const convertAnyWho5AssessmentsToPositiveBaseScore = (assessmentScores) => {
  for (let score of assessmentScores) {
    if (score.assessmentName === 'who-5') {
      score.score = score.score / -4;
    }
  }
};
